import React, { useState, useEffect } from 'react';
import axios from 'src/utils/axios';
import {
  Button,
  Grid,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
  Backdrop,
  CircularProgress,
  Snackbar,
  Box,
  Select,
  InputLabel,
  MenuItem,
  Autocomplete,
  Checkbox
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Skeleton from '@mui/material/Skeleton';
import Alert from 'src/components/Alert';
import CloseIcon from '@material-ui/icons/Close';

const ReportRequestScreen_2 = () => {
  const [years, setYears] = useState([]);
  const [products, setProducts] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  let currentYear = new Date().getFullYear();

  const [selectedManufacturer, setSelectedManufacturer] = useState([]);
  const [zipEnabled, setZipEnabled] = useState(true);

  const [productSearchPopUp, setProductSearchPopUp] = React.useState(false);
  const [serviceSearchPopUp, setServiceSearchPopUp] = React.useState(false);
  const [searchType, setSearchType] = React.useState(1);
  const [searchType2, setSearchType2] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [searchTerm2, setSearchTerm2] = React.useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchResults2, setSearchResults2] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedServices, setSelectedServices] = useState(null);
  const [uyari, setUyari] = React.useState('');
  const [uyariTip, setUyariTip] = React.useState(false);

  const [modelCodeInput, setModelCodeInput] = React.useState('');
  const [serviceCodeInput, setServiceCodeInput] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [responseMessage, setresponseMessage] = React.useState('');

  const [manuFacturerGeneralData, setManuFacturerGeneralData] = React.useState(
    []
  );

  useEffect(() => {
    getmanufacturerGeneralData();
  }, []);

  // Manuel olarak yılları ekleyelim
  while (currentYear >= 2010) {
    years.push(currentYear);
    currentYear--;
  }

  const handleSubmit = () => {
    if (!selectedYear || !selectedProduct || !selectedManufacturer) {
      alert('Eksik veri girişi!');
      return;
    }

    console.log('Form Submitted', {
      selectedYear,
      selectedProduct,
      selectedManufacturer,
      zipEnabled
    });
  };

  const handleSearch = () => {
    if (searchTerm.length <= 0) {
      setresponseMessage('Lütfen kutucukları boş bırakmayınız!...');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    const data = {
      SearchType: searchType,
      SearchTerm: searchTerm
    };
    setLoading(true);
    axios
      .get(`GetModelCodesOfProducts/${data.SearchType}/${data.SearchTerm}`)
      .then(response => {
        var data = response.data;
        setSearchResults(data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const handleSearch2 = () => {
    if (searchTerm2.length <= 0) {
      setresponseMessage('Lütfen kutucukları boş bırakmayınız!...');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    const data = {
      SearchType: searchType2,
      SearchTerm: searchTerm2
    };
    setLoading(true);
    axios
      .get(`GetModelCodesOfServices/${data.SearchType}/${data.SearchTerm}`)
      .then(response => {
        var data = response.data;
        setSearchResults2(data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const handleSelectProduct = product => {
    setModelCodeInput(product.KUL_MODEL_KODU + ' - ' + product.ACIKLAMA);
    setSelectedProduct(product.MODEL_KODU);
    setProductSearchPopUp(false);
    setSearchResults([]);
    setSearchTerm('');
    setSearchResults2([]);
  };

  const handleSelectServices = services => {
    setServiceCodeInput(services.KUL_HIZMET_KODU + ' - ' + services.ACIKLAMA);
    setSelectedServices(services.HIZMET_KODU);
    setServiceSearchPopUp(false);
    setSearchResults2([]);
    setSearchTerm2('');
  };

  const getmanufacturerGeneralData = () => {
    axios.get('/GetUreticiTablo').then(response => {
      const data = response.data;
      setManuFacturerGeneralData(data);
    });
  };

  const handleTemizle = () => {
    setSelectedYear('');
    setModelCodeInput('');
    setSelectedManufacturer([]);
    setServiceCodeInput('');
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Rapor Giriş Parametreleri
      </Typography>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="year-select-label">Yıl</InputLabel>
              <Select
                labelId="year-select-label"
                value={selectedYear}
                label="Yıl"
                onChange={e => setSelectedYear(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // Menü yüksekliği (kaydırma için)
                      width: 250 // Menü genişliği
                    }
                  },
                  MenuListProps: {
                    style: {
                      display: 'block'
                    }
                  }
                }}
              >
                {years.map(year => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              label="Ürün Model Kodu"
              size="medium"
              value={modelCodeInput ? modelCodeInput : ''}
              disabled
              fullWidth
              variant="outlined"
              inputProps={{
                style: {
                  fontWeight: 'bold',
                  opacity: 1,
                  color: 'black',
                  cursor: 'text'
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setProductSearchPopUp(true);
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Autocomplete
              fullWidth
              value={selectedManufacturer}
              options={manuFacturerGeneralData}
              getOptionLabel={option =>
                option.ACIKLAMA ? option.ACIKLAMA : ''
              }
              onChange={(event, newValue) => {
                setSelectedManufacturer(newValue);
              }}
              renderInput={params => (
                <TextField {...params} label="Üreticiler" variant="outlined" />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              label="Ürün Hizmet Kodu"
              size="medium"
              value={serviceCodeInput ? serviceCodeInput : ''}
              disabled
              fullWidth
              variant="outlined"
              inputProps={{
                style: {
                  fontWeight: 'bold',
                  opacity: 1,
                  color: 'black',
                  cursor: 'text'
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setServiceSearchPopUp(true);
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={zipEnabled}
                  onChange={() => setZipEnabled(!zipEnabled)}
                />
              }
              label="ZIP (Sıkıştırma)"
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleSubmit}
              sx={{ mr: 2 }}
            >
              Gönder
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              type="reset"
              onClick={handleTemizle}
            >
              Temizle
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* BURASI ÇOK AYRI BİR DÜNYA ELLEMEYİN */}
      {/* Burası Model kodu için*/}

      <Dialog open={productSearchPopUp} maxWidth="md" fullWidth>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl>
                <FormLabel>Arama Türü</FormLabel>
                <RadioGroup
                  row
                  aria-label="searchType"
                  name="searchType"
                  value={searchType}
                  onChange={e => setSearchType(Number(e.target.value))}
                >
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="Model Koduna göre arama"
                  />
                  <FormControlLabel
                    value={2}
                    control={<Radio />}
                    label="Açıklamaya göre arama"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label="Model Arama"
                fullWidth
                size="medium"
                variant="outlined"
                margin="normal"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Button
                color="secondary"
                variant="contained"
                size="medium"
                fullWidth
                onClick={() => {
                  handleSearch();
                }}
              >
                Arama Yap
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Divider style={{ margin: '1rem' }} />
              <TableContainer component={Paper}>
                <Table size="medium">
                  <TableHead>
                    <TableRow
                      style={{ backgroundColor: '#0033a0', color: '#fff' }}
                    >
                      <TableCell colSpan={2}>
                        <Typography
                          variant="h5"
                          align="center"
                          style={{ color: '#fff' }}
                        >
                          Ürün Listesi
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{ border: '1px solid #ddd' }}
                      >
                        Model Kodu
                      </TableCell>
                      <TableCell style={{ border: '1px solid #ddd' }}>
                        Açıklama
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading
                      ? Array.from(new Array(4)).map((_, index) => (
                          <TableRow key={index}>
                            {Array.from(new Array(2)).map((_, cellIndex) => (
                              <TableCell key={cellIndex} colSpan={1}>
                                <Skeleton
                                  animation="pulse"
                                  variant="text"
                                  width={300}
                                />
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      : searchResults.length > 0 &&
                        searchResults.map((result, index) => (
                          <TableRow
                            key={index}
                            onClick={() => handleSelectProduct(result)}
                            style={{ cursor: 'pointer' }}
                          >
                            <TableCell
                              align="center"
                              style={{ border: '1px solid #ddd' }}
                            >
                              {result.KUL_MODEL_KODU}
                            </TableCell>
                            <TableCell style={{ border: '1px solid #ddd' }}>
                              {result.ACIKLAMA}
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => {
              setProductSearchPopUp(false);
              setSearchResults([]);
              setSearchTerm([]);
            }}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      {/* BURASI ÇOK AYRI BİR DÜNYA ELLEMEYİN */}
      {/* Burası Hizmet kodu için*/}

      <Dialog open={serviceSearchPopUp} maxWidth="md" fullWidth>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl>
                <FormLabel>Arama Türü</FormLabel>
                <RadioGroup
                  row
                  aria-label="searchType"
                  name="searchType"
                  value={searchType2}
                  onChange={e => setSearchType2(Number(e.target.value))}
                >
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="Hizmet Koduna göre arama"
                  />
                  <FormControlLabel
                    value={2}
                    control={<Radio />}
                    label="Açıklamaya göre arama"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label="Hizmet Arama"
                fullWidth
                size="medium"
                variant="outlined"
                margin="normal"
                value={searchTerm2}
                onChange={e => setSearchTerm2(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Button
                color="secondary"
                variant="contained"
                size="medium"
                fullWidth
                onClick={() => {
                  handleSearch2();
                }}
              >
                Arama Yap
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Divider style={{ margin: '1rem' }} />
              <TableContainer component={Paper}>
                <Table size="medium">
                  <TableHead>
                    <TableRow
                      style={{ backgroundColor: '#0033a0', color: '#fff' }}
                    >
                      <TableCell colSpan={2}>
                        <Typography
                          variant="h5"
                          align="center"
                          style={{ color: '#fff' }}
                        >
                          Hizmet Listesi
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{ border: '1px solid #ddd' }}
                      >
                        Hizmet Kodu
                      </TableCell>
                      <TableCell style={{ border: '1px solid #ddd' }}>
                        Açıklama
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading
                      ? Array.from(new Array(4)).map((_, index) => (
                          <TableRow key={index}>
                            {Array.from(new Array(2)).map((_, cellIndex) => (
                              <TableCell key={cellIndex} colSpan={1}>
                                <Skeleton
                                  animation="pulse"
                                  variant="text"
                                  width={300}
                                />
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      : searchResults2.length > 0 &&
                        searchResults2.map((result, index) => (
                          <TableRow
                            key={index}
                            onClick={() => handleSelectServices(result)}
                            style={{ cursor: 'pointer' }}
                          >
                            <TableCell
                              align="center"
                              style={{ border: '1px solid #ddd' }}
                            >
                              {result.KUL_HIZMET_KODU}
                            </TableCell>
                            <TableCell style={{ border: '1px solid #ddd' }}>
                              {result.ACIKLAMA}
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => {
              setServiceSearchPopUp(false);
              setSearchResults2([]);
              setSearchTerm2([]);
            }}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ReportRequestScreen_2;
